module.exports = __webpack_public_path__ + "img/icon-check-round.eb17adea.svg";